<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<div class="column" (dragleave)="onDragLeave()">
  <div class="header" [ngClass]="{ current: isCurrentDay }">
    <span
      class="label"
      [innerHTML]="day() | customDate: 'DD' : translate.currentLang : false"
    ></span>
  </div>
  <div
    class="calendar"
    [style.background-color]="dayBackgroundColor()"
    (dragenter)="$event.preventDefault()"
    (dragover)="$event.preventDefault()"
    (mousemove)="onMouseMove($event)"
  >
    <div class="tasks">
      <div #taskColumn class="task-column">
        @for (task of viewTasks; track task.task.id) {
          <div
            class="task"
            [ngStyle]="task.style"
            [draggable]="task.task.enable && canDrag()"
            (dblclick)="onTaskDblClick($event, task.task)"
            (dragstart)="onDragStart(task, $event)"
            (dragend)="enablePointerEvent()"
            (dragover)="allowDrop($event)"
            (mouseenter)="taskHover.emit(task.task)"
            (mouseleave)="taskHover.emit(null)"
            (drop)="onDrop($event)"
            (click)="onTaskClick($event, task.task)"
          >
            @if (canResize() && task.task.enable) {
              <div
                class="resize-box"
                (mousedown)="onTaskResize(task, $event, 'top')"
              >
                <!--            <span class="fal fa-ellipsis-h"></span>-->
              </div>
            }
            <div
              class="background"
              [ngStyle]="{
                'background-color':
                  task.task.backgroundColor.length === 9
                    ? task.task.backgroundColor
                    : task.task.backgroundColor + 'BF',
              }"
            >
              <div
                class="task-content"
                [ngClass]="{ disable: !canResize() || !task.task.enable }"
              >
                <div class="text">
                  @if (task.task.icon) {
                    <span class="icon fal fa-{{ task.task.icon }}"></span>
                  }
                </div>
                <div class="content" [innerHTML]="task.task.label">
                  {{ task.task.label }}
                </div>
              </div>
            </div>
            @if (canResize() && task.task.enable) {
              <div
                class="resize-box bottom"
                (mousedown)="onTaskResize(task, $event, 'bottom')"
              >
                <!--            <span class="fal fa-ellipsis-h"></span>-->
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (isCurrentDay) {
      <div>
        <div class="hour-line" [ngStyle]="hourLineStyle"></div>
      </div>
    }
    @for (zone of zones; track zone.hour) {
      <div class="zone" (dragleave)="onDragLeave()">
        @for (sub of zone.zones; track sub.minutes) {
          <div
            inflDayRow
            #hourSection
            class="sub"
            [class.selected]="sub.selected"
            [draggable]="false"
            [attr.data-hour]="zone.hour"
            [attr.data-time]="sub.minutes"
            [title]="sub.text"
            (mousedown)="selectZone($event, zone.hour, sub)"
            (contextmenu)="onRightClick($event)"
            (mouseover)="overZone($event, zone.hour, sub.minutes, sub)"
            (dblclick)="onDblClick($event)"
            (dragover)="allowDrop($event)"
            (drop)="onDropTask(zone, sub)"
          ></div>
        }
      </div>
    }
  </div>
</div>
